import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";
import { Service } from "../models/service";

@Injectable()
export class ServicesService {
  constructor(private apollo: Apollo) {}

  getAllServices(obj?) {
    let variables = {};
    console.log("obj", obj);

    if (obj) {
      variables = {
        first: obj.paginationData.pageSize || 10, // Default to 10 if pageSize is not provided
        after: obj.paginationData.after
          ? obj.paginationData.after.endCursor
          : null, // Use null if no cursor is provided
        searchParam: obj.searchParam || null, // Use null if no searchParam is provided
      };
    }

    return this.apollo.watchQuery({
      query: gql`
        query getServices($first: Int, $after: String, $searchParam: String) {
          services(first: $first, after: $after, searchParam: $searchParam) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                type
                options
              }
              cursor
            }
            totalCount
          }
        }
      `,
      variables,
      errorPolicy: "all", // Ensures the query doesn't fail if there's a minor error
    }).valueChanges;
  }

  findOneService(id: string) {
    return this.apollo.watchQuery({
      query: gql`
          {
            service(id: "${id}") {
              id
              type
              options
              description
              photos {
                id
                url
                originalUrl
                path
                mimetype
                credit
                caption
                editor
              }
            }
          }
        `,
    }).valueChanges;
  }

  createService(service: Service) {
    return this.apollo.mutate({
      mutation: gql`
        mutation createService(
          $type: String
          $options: [String]
          $description: String
        ) {
          createService(
            service: {
              type: $type
              options: $options
              description: $description
            }
          ) {
            id
            type
            options
            description
          }
        }
      `,
      variables: {
        type: service.type,
        options: service.options,
        description: service.description,
      },
    });
  }

  updateService(service: Service) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateService(
          $id: ID!
          $type: String
          $options: [String]
          $description: String
        ) {
          updateService(
            service: {
              id: $id
              type: $type
              options: $options
              description: $description
            }
          ) {
            success
          }
        }
      `,
      variables: {
        id: service.id,
        type: service.type,
        options: service.options,
        description: service.description,
      },
    });
  }

  deleteService(service: Service) {
    return this.apollo.mutate({
      mutation: gql`
          mutation removeService {
            removeService(id: "${service.id}") {
              success
            }
          }
        `,
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/services.service.ts